var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 68,
    viewBox: "0 0 93 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35848 13.2717L72.591 2.18808C73.9552 1.96967 75.2382 2.89855 75.4566 4.26279C75.4571 4.26552 75.4575 4.26825 75.4579 4.27098L82.2305 47.4924C82.4439 48.8541 81.5155 50.1319 80.1545 50.3498L10.922 61.4334C9.55772 61.6518 8.27473 60.7229 8.05633 59.3587C8.05589 59.3559 8.05545 59.3532 8.05502 59.3505L1.28247 16.1291C1.06909 14.7674 1.99744 13.4896 3.35848 13.2717Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 60.7242L11.8717 61.1617C10.0482 61.4622 8.33595 60.1676 8.04708 58.2702L1.77211 17.0423C1.48331 15.1449 2.72736 13.363 4.55078 13.0625L71.4078 2.04332C73.2313 1.74285 74.9436 3.03742 75.2324 4.93487C75.5137 6.78364 75.738 8.25702 75.9051 9.35503M76.3818 12.4866C76.5331 13.4812 76.6657 14.3521 76.7794 15.0994",
    stroke: "#374151",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71563 15.1694L69.8902 5.30375C71.2511 5.09123 72.5277 6.01873 72.7462 7.37865L78.8836 45.5859C79.1028 46.95 78.1745 48.2335 76.8104 48.4526C76.8068 48.4532 76.8032 48.4538 76.7996 48.4543L13.6251 58.3199C12.2642 58.5325 10.9876 57.6049 10.7691 56.245L4.63165 18.0378C4.41252 16.6737 5.34072 15.3902 6.70485 15.1711C6.70844 15.1705 6.71203 15.1699 6.71563 15.1694Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4121 18.8867H21.9527C20.1105 18.8867 18.6172 20.3801 18.6172 22.2222V62.665C18.6172 64.5072 20.1105 66.0005 21.9527 66.0005H87.4121C89.2542 66.0005 90.7476 64.5072 90.7476 62.665V22.2222C90.7476 20.3801 89.2542 18.8867 87.4121 18.8867Z",
    fill: "white",
    stroke: "#374151",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7039 28.6836H19.6582V40.3578H89.7039V28.6836Z",
    fill: "#F9FAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1723 29.5195H57.5723",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4523 34.8359H57.5723",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4523 39.957H57.5723",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1723 50.1953H57.5723",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1723 55.3164H57.5723",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4121 18.8867H21.9527C20.1105 18.8867 18.6172 20.3801 18.6172 22.2222V62.665C18.6172 64.5072 20.1105 66.0005 21.9527 66.0005H87.4121C89.2542 66.0005 90.7476 64.5072 90.7476 62.665V22.2222C90.7476 20.3801 89.2542 18.8867 87.4121 18.8867Z",
    stroke: "#374151",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9316 31.0391C24.9316 27.7254 27.6179 25.0391 30.9316 25.0391H45.8117C49.1254 25.0391 51.8117 27.7254 51.8117 31.0391V53.5989C51.8117 56.9126 49.1254 59.5989 45.8117 59.5989H30.9316C27.6179 59.5989 24.9316 56.9126 24.9316 53.5989V31.0391Z",
    fill: "#E5E7EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3716 42.2561C41.76 42.2561 44.5156 39.5436 44.5156 36.2081C44.5156 32.8727 41.76 30.1602 38.3716 30.1602C34.9832 30.1602 32.2276 32.8727 32.2276 36.2081C32.2276 39.5436 34.9832 42.2561 38.3716 42.2561ZM40.6756 43.7681H36.0676C30.9849 43.7681 26.8516 47.8369 26.8516 52.8401V54.3521H28.3876H29.9236H46.8196H48.3556H49.8916V52.8401C49.8916 47.8369 45.7582 43.7681 40.6756 43.7681Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdVerification);
export default __webpack_public_path__ + "static/media/id-verification.a40c6d833965f4b19eb9f4118549fb40.svg";
export { ForwardRef as ReactComponent };